import { render, staticRenderFns } from "./assign-product.vue?vue&type=template&id=58dded00&"
import script from "./assign-product.vue?vue&type=script&lang=js&"
export * from "./assign-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports